import React, { FC } from 'react';

import css from './CircleSpinner.css';

const CircleSpinner: FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <div className={css.loader}>
            <div className={css.loadingSpinner}>
                <svg
                    className={css.loadingSpinnerCircleSvg}
                    viewBox="25 25 50 50"
                >
                    <circle
                        className={css.loadingSpinnerCircleStroke}
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                    />
                </svg>
            </div>
        </div>
    );
};

export default CircleSpinner;
